module.exports = __webpack_public_path__ + "img/build-team.437433dd.png";